import React from 'react';
import Icon from './Icon';

export default class LateTime extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.635 5.713a8.696 8.696 0 0 1 2.032 5.577c0 4.758-3.852 8.71-8.667 8.71-4.814 0-8.667-3.952-8.667-8.71 0-4.562 3.497-8.26 7.865-8.668V2H7.242a.467.467 0 0 1-.467-.464V.464c0-.255.21-.464.467-.464h5.515c.257 0 .468.209.468.464v1.072c0 .255-.21.464-.468.464h-1.954v.622c1.71.158 3.267.82 4.54 1.827l1.427-1.843a.471.471 0 0 1 .656-.086l.686.523a.463.463 0 0 1 .086.651l-1.563 2.02zM10 18.306c3.931 0 7.062-3.226 7.062-7.097 0-3.87-3.13-7.096-7.062-7.096-3.931 0-7.062 3.225-7.062 7.096 0 3.952 3.21 7.097 7.062 7.097zm.473-6.706h-.946a.467.467 0 0 1-.468-.464V5.664c0-.255.21-.464.468-.464h.946c.257 0 .467.209.467.464v5.472c0 .255-.21.464-.467.464z"
      />
    </svg>
  );
}
